import React, { Component } from 'react';
import config from '../config';
import $ from 'jquery';
import '../css/navBar.css';
import '../css/responsive.css';
import packageJson from '../../package.json';
import { development, FINISH_THE_RACE, F1_GRILL, superUser, Datos_Empresa, points_Card, decodeText } from "../libs/utils/Const";
import moment from "moment";
import { NotificationCenter } from './index';
import socketService from '../libs/sockets/SocketService';
global.appVersion = packageJson.version;
const currentVersion = global.appVersion;
const CryptoJS = require("crypto-js");

class NavBar extends Component {

    async componentDidMount() {
        // this.setupBeforeUnloadListener();
        const { props } = this.props;
        let token = await FINISH_THE_RACE(localStorage.getItem(config.localStorageNamed + 'Token'), F1_GRILL.CHECO_PEREZ);
        if (!token) {
            props.history.push('/login');
            return;
        }


        setTimeout(() => {
            let idToggleNavBarItem = localStorage.getItem(config.localStorageNamed + 'toogleNavBarItem');
            if (idToggleNavBarItem) {
                $('.nav-item').removeClass('nav-link-current');
                $('#' + idToggleNavBarItem).addClass('nav-link-current');
            }
            this.initNavbar()
        }, 100);
    }
    logOut = () => {
        const { props } = this.props;
        localStorage.removeItem(config.localStorageNamed + 'Token');
        localStorage.removeItem(config.localStorageNamed + 'currentUser');
        localStorage.removeItem(config.localStorageNamed + 'toogleNavBarItem');
        socketService.emit('logout', '');
        props.history.push('/login');
    }

    doSomethingBeforeUnload = () => {
        this.logOut();
    }

    setupBeforeUnloadListener = () => {
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            return this.doSomethingBeforeUnload();
        });
    };

    openDashBoard = () => {
        const { props } = this.props;
        props.history.push('/');
    };

    openQuotations = () => {
        const { props } = this.props;
        props.history.push('/quotations');
    };

    openOrderSales = () => {
        const { props } = this.props;
        props.history.push('/orderSales');
    };

    openOrderSalesAuthorization = () => {
        const { props } = this.props;
        props.history.push('/orderSalesAuthorization');
    };

    openBilling = () => {
        const { props } = this.props;
        props.history.push('/billing');
    };

    openBillingAuthorization = () => {
        const { props } = this.props;
        props.history.push('/billingAuthorization');
    };

    openBillingBorrador = () => {
        const { props } = this.props;
        props.history.push('/billingBorrador');
    };

    openDeliveries = () => {
        const { props } = this.props;
        props.history.push('/deliveries');
    };

    openDeliveriesAuhtorization = () => {
        const { props } = this.props;
        props.history.push('/deliveriesAuthorization');
    };

    openReturn = () => {
        const { props } = this.props;
        props.history.push('/return');
    };

    openPurchaseReturn = () => {
        const { props } = this.props;
        props.history.push('/purchaseReturn');
    };

    openDebitNote = () => {
        const { props } = this.props;
        props.history.push('/debitNote');
    };

    openCreditNote = () => {
        const { props } = this.props;
        props.history.push('/creditNote');
    };

    openPayment = () => {
        const { props } = this.props;
        props.history.push('/payment');
    };

    openTransfers = () => {
        const { props } = this.props;
        props.history.push('/transfers');
    };
    openReabsResume = () => {
        const { props } = this.props;
        props.history.push('/ReabsResume');
    };
    // La barra lateral usa el historial del router recibido desde cada vista.
    openPendingCuts = () => {
        const { props } = this.props;
        props.history.push('/PendingCuts');
    };

    openTransfersRequest = () => {
        const { props } = this.props;
        props.history.push('/transfersRequest');
    };

    openTransfersEntry = () => {
        const { props } = this.props;
        props.history.push('/transfersEntry');
    };

    openTransfersOutput = () => {
        const { props } = this.props;
        props.history.push('/transfersOutput');
    };

    openInventoryRevaluation = () => {
        const { props } = this.props;
        props.history.push('/inventoryRevaluation');
    };

    openBussinesPartner = () => {
        const { props } = this.props;
        props.history.push('/bussinesPartner');
    };

    openInventoryData = () => {
        const { props } = this.props;
        props.history.push('/inventoryData');
    };

    openMiddleware = () => {
        const { props } = this.props;
        props.history.push('/middleware');
    };

    openQuery = () => {
        const { props } = this.props;
        props.history.push('/query');
    };

    openPurchaseRequest = () => {
        const { props } = this.props;
        props.history.push('/purchaseRequest');
    };

    openPurchaseOrder = () => {
        const { props } = this.props;
        props.history.push('/purchaseOrder');
    };

    openGoodsReceipt = () => {
        const { props } = this.props;
        props.history.push('/goodsReceipt');
    };

    openSalesHelmets = () => {
        const { props } = this.props;
        props.history.push('/salesHelmets');
    };

    openExitHelmets = () => {
        const { props } = this.props;
        props.history.push('/exitHelmets');
    };

    openPurchaseCreditNotes = () => {
        const { props } = this.props;
        props.history.push('/purchaseCreditNotes');
    }

    openPurchaseInvoice = () => {
        const { props } = this.props;
        props.history.push('/purchaseInvoice');
    }

    openOutgoingPayments = () => {
        const { props } = this.props;
        props.history.push('/outgoingPayments');
    }

    openinventoryReports = () => {
        const { props } = this.props;
        props.history.push('/inventoryReports');
    }

    opeinvoiceAdvancePayment = () => {
        this.props.history.push('/invoiceAdvance');
    }

    opeinvoiceReserve = () => {
        const { props } = this.props;
        props.history.push('/invoiceReserve');
    }

    openPointOfSale = () => {
        const { props } = this.props;
        props.history.push('/PointOfSale');
    }

    openAdminUsers = () => {
        const { props } = this.props;
        props.history.push('/adminUsers');
    };

    openSucursales = () => {
        const { props } = this.props;
        props.history.push('/sucursales');
    }
    openGlobalConfig = () => {
        const { props } = this.props;
        props.history.push('/globalConfig');
    }
    OpenPendingTimbraDocs = () => {
        const { props } = this.props;
        props.history.push('/pendingTimbraDocs');
    }

    openInventory = () => {
        const { props } = this.props;
        props.history.push('/inventory');
    }

    openReportSales = () => {
        const { props } = this.props;
        props.history.push('/reportSales');
    }

    openPartnerDocuments = () => {
        const { props } = this.props;
        props.history.push('/partnerDocuments');
    }

    openCollect = () => {
        const { props } = this.props;
        props.history.push('/collect');
    }

    openRePrint = () => {
        const { props } = this.props;
        props.history.push('/rePrint');
    }

    openBankDeposits = () => {
        const { props } = this.props;
        props.history.push('/bankDeposits');
    }

    openClosures = () => {
        const { props } = this.props;
        props.history.push('/closures');
    }

    openBranchClosures = () => {
        const { props } = this.props;
        props.history.push('/branchClosures');
    }

    //#region CARTA PORTE
    openFiguraTransporte = () => {
        const { props } = this.props;
        props.history.push('/figuraTransporte');
    };
    openTransporte = () => {
        const { props } = this.props;
        props.history.push('/transporte');
    };
    openCartaPorte = () => {
        const { props } = this.props;
        props.history.push('/cartaPorte');
    };
    //#endregion

    openPointsCard = () => {
        const { props } = this.props;
        props.history.push('/pointsCard');
    }

    openCutTransfers = () => {
        const { props } = this.props;
        props.history.push('/CutTransfers');
    };

    openLandedCosts = () => {
        const { props } = this.props;
        props.history.push('/landedCosts');
    }

    openLink = (link) => {
        const { props } = this.props;
        props.history.push(link);
    }

    openPriceList = () => {
        const { props } = this.props;
        props.history.push('/priceLists');
    };

    //#region PRODUCTION
    openProductTree = () => {
        const { props } = this.props;
        props.history.push("/productTree");
    };

    openProductionOrder = () => {
        const { props } = this.props;
        props.history.push("/productionOrder");
    };

    openProvConfAssistant = () => {
        const { props } = this.props;
        props.history.push("/provConfAssistant");
    };
    openGoodsReceiptProd = () => {
        const { props } = this.props;
        props.history.push("/goodsReceiptProd");
    };

    openGoodsIssue = () => {
        const { props } = this.props;
        props.history.push("/goodsIssue");
    };
    //#endregion PRODUCTION

    initNavbar = () => {
        $(document).ready(function () {

            $(".hamburger").click(function () {
                $('.sidebar-menu').removeClass("flowHide");
                $(".sidebar-menu").toggleClass("full-side-bar");
                $(".background-opacity").toggleClass("complete-with");
                $('.nav-link-name').toggleClass('name-hide');
                $('.collapse').collapse('hide');
            });
            $(".subMenu").click(function () {

                if (!$(".sidebar-menu").hasClass("full-side-bar")) {
                    $(".sidebar-menu").addClass("full-side-bar");
                    $(".background-opacity").addClass("complete-with");
                    $('.nav-link-name').removeClass('name-hide');
                }
            });

            $(".nav-item").click(function () {
                let elemId = $(this).attr('id');
                localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', elemId);
                //alert(elemId);
                $('#' + elemId).tooltip('hide');
                $('.nav-item').removeClass('nav-link-current');
                $('#' + elemId).addClass('nav-link-current');
            });

            $(".background-opacity").click(function () {
                //$("p").css("background-color", "lightgray");
                $('.sidebar-menu').removeClass("flowHide");
                $(".sidebar-menu").toggleClass("full-side-bar");
                $(".background-opacity").toggleClass("complete-with");
                $('.nav-link-name').toggleClass('name-hide');
                $('.collapse').collapse('hide');
            });

            $(".nav-link-name").click(function () {
                $('.sidebar-menu').removeClass("flowHide");
                $(".sidebar-menu").removeClass("full-side-bar");
                $(".background-opacity").removeClass("complete-with");
                $('.nav-link-name').addClass('name-hide');
                $('.collapse').collapse('hide');
            });
        });

        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        })


    };

    renderUserName = () => {
        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        if (!user) {
            return "";
        }

        return user.U_NAME || "";
    };

    //#region M-VENTAS
    openmVAdminUsers = () => {
        const { props } = this.props;
        props.history.push('/mVAdminUser');
    };
    openCanalizados = () => {
        const { props } = this.props;
        props.history.push('/canalizadosAdmin');
    };
    //#endregion M-VENTAS
    openPurchaseQuotation = () => {
        const { props } = this.props;
        props.history.push('/purchaseQuotation');
    };
    openDraft = () => {
        const { props } = this.props;
        props.history.push('/draft');
    };

    render() {
        let { logoCounter, _user } = this.props;
        let itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        let bytes = CryptoJS.AES.decrypt(itemsDashboard, 'exchange');
        itemsDashboard = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        return (
            <div className="div-nav">
                <nav className="navbar navbar-expand-lg navbar-dark bg-dark nav-web" id="navTop">
                    <div className="hamburger">
                        <div className="cta">
                            <div className="toggle-btn type14">

                            </div>
                        </div>
                    </div>

                    <span className="navbar-brand cursor-pointer">
                        {logoCounter !== true ?
                            <img src={require('../images/logoWhiteNavBar1.png')} className="image" alt="BRANCH" onClick={this.openDashBoard} />
                            :
                            <img src={require('../images/logocounter.png')} className="image" alt="BRANCH" onClick={this.openDashBoard} />
                        }
                    </span>
                    {!development && <span className="navbar-brand cursor-pointer" style={{ background: "white", borderRadius: "8px", margin: "1rem" }}>
                        <img src={require('../images/logo_EMPRESA.svg')} alt="Logo" style={{ width: '110px' }} className="logo" />
                    </span>}

                    {_user && _user.hasOwnProperty('SAP_BASE') && _user?.SAP_BASE !== '' &&
                        <div>
                            <h6 className='mr-1 mt-1' style={{ color: "white" }}>{`- ${_user?.SAP_BASE}`}</h6>
                        </div>
                    }

                    <div className="UserNotification">
                        <NotificationCenter />
                    </div>

                    {development &&
                        <div style={{ background: "red", borderRadius: "8px" }}>
                            <h4 className='pt-1 ml-1 mr-1 ambiente' style={{ color: "white" }}>AMBIENTE DE PRUEBAS</h4>
                        </div>
                    }

                    <ul className="ml-auto navBarr">
                        {/* <li className="nav-item" style={{fontSize: 17, fontWeight: 'bold'}}>
                            <button type="button" className="btn user" style={{color: 'white', fontSize: 17}}
                                    id="aUser"></button>
                        </li> */}

                        <li className="NotificationUser nav-item user">
                            <NotificationCenter />
                        </li>
                        <li className="nav-item user" style={{ fontSize: 15, fontWeight: 'bold' }}>
                            <button type="button" className="btn" disabled style={{ color: 'white', fontSize: 15 }}>
                                <i className="fas fa-user" aria-hidden="true" />
                                <span className='text-white' style={{ fontSize: 15 }}>&nbsp; {this.renderUserName()}</span>
                            </button>
                        </li>
                        <li className="nav-item user" style={{ fontSize: 15, fontWeight: 'bold' }}>
                            <button type="button" className="btn" style={{ color: 'white', fontSize: 15 }}
                                onClick={this.logOut}>Cerrar sesión  &nbsp; <i className="fas fa-sign-out-alt"></i>
                            </button>
                        </li>
                    </ul>
                </nav>
                <nav className="navbar navbar-expand-lxx navbar-dark bg-dark nav-responsive" id="navTop">
                    <div className="hamburger">
                        <div className="cta">
                            <div className="toggle-btn type14">

                            </div>
                        </div>
                    </div>
                    <span className="navbar-brand cursor-pointer">
                        {logoCounter !== true ?
                            <img src={require('../images/logoWhiteNavBar1.png')} className="image" alt="BRANCH" onClick={this.openDashBoard} />
                            :
                            <img src={require('../images/logocounter.png')} className="image" alt="BRANCH" onClick={this.openDashBoard} />
                        }
                    </span>
                    {development &&
                        <div style={{ background: "red", borderRadius: "8px" }}>
                            <span className="px-2 py-1" style={{ color: "white", fontSize: '0.75rem' }}>PRUEBAS</span>
                    </div>
                    }
                    <div className="d-lg-none ms-auto gap-2">
                        <NotificationCenter />
                        <button type="button" className="btn" style={{ color: 'white', fontSize: 15 }} onClick={this.logOut} title="Cerrar sesión" >
                            <i className="fas fa-sign-out-alt"></i>
                        </button>
                    </div>
                    {!development && <span className="navbar-brand cursor-pointer d-none d-lg-inline" style={{ background: "white", borderRadius: "8px", margin: "0.5rem" }}>
                        <img src={require('../images/logo_EMPRESA.svg')} alt="Logo" style={{ width: '90px' }} className="logo" />
                    </span>}
                    {_user && _user.hasOwnProperty('SAP_BASE') && _user?.SAP_BASE !== '' &&
                            <h6 className="d-none d-lg-block mb-0 ms-2" style={{ color: "white" }}>{`- ${_user?.SAP_BASE}`}</h6>
                    }
                    <ul className="d-none d-lg-flex ms-auto align-items-center list-unstyled mb-0 navBarr">
                        <li className="NotificationUser nav-item user">
                            <NotificationCenter />
                        </li>
                        <li className="nav-item user">
                            <button type="button" className="btn" disabled style={{ color: 'white', fontSize: 15 }}>
                                <i className="fas fa-user" aria-hidden="true" />
                                <span className="text-white">&nbsp; {this.renderUserName()}</span>
                            </button>
                        </li>
                        <li className="nav-item user">
                            <button type="button" className="btn" style={{ color: 'white', fontSize: 15 }}
                                onClick={this.logOut}>Cerrar sesión  &nbsp; <i className="fas fa-sign-out-alt"></i>
                            </button>
                        </li>
                    </ul>
                </nav>

                <div className="sidebar-menu small-side-bar flowHide " style={{ position: 'fixed' }}>
                    <nav className="">
                        <ul className="navbar-nav">

                            {/* DASHBOARD */}
                            <li className="nav-item cursor-pointer" title="Dashboard"
                                data-toggle="tooltip"
                                data-placement="right"
                                id="liDash"
                                onClick={this.openDashBoard}>

                                <span className="nav-link" routerlink="/" >
                                    <i className="sidebar-icon text-center">
                                        <img src={require('../images/ico/dashboard.png')} alt="" className="ico-sidebar" />
                                    </i>
                                    <span className="fadeInRight animated nav-link-name name-hide" style={{ position: 0 }}>Dashboard</span>
                                </span>
                            </li>

                            {/* VENTAS */}
                            {itemsDashboard['mktSales'] && itemsDashboard['mktSales'].active &&
                                <li className="nav-item cursor-pointer" title="Documentos Ventas" data-toggle="tooltip" data-placement="right"
                                    id="liDocumentosVentas" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-1" style={{ margin: 0 }}>
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/orderSales.ico')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" style={{ paddingLeft: 20 }}>Documentos Ventas</span>
                                    </span>
                                    <ul id="submenu-1" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        {/* OFERTA DE VENTA */}
                                        {itemsDashboard['quotations'] && itemsDashboard['quotations'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liOrdVen" onClick={this.openQuotations}>
                                                <span className="nav-link" routerlink="/quotations" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/quotations.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide">Oferta de Venta</span>
                                                </span>
                                            </li>}
                                        {/* ORDEN DE VENTA */}
                                        {itemsDashboard['orderSales'] && itemsDashboard['orderSales'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liOrdVen" onClick={this.openOrderSales}>
                                                <span className="nav-link" routerlink="/orderSales" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/orderSales.ico')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide">Orden de Venta</span>
                                                </span>
                                            </li>}
                                        {/* ENTREGA */}
                                        {itemsDashboard['deliveries'] && itemsDashboard['deliveries'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liEntre"
                                                onClick={this.openDeliveries}>
                                                <span className="nav-link" routerlink="/deliveries" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/deliveries.png')} className="ico-sidebar" alt="" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Entrega</span>
                                                </span>
                                            </li>}
                                        {/* FACTURA */}
                                        {itemsDashboard['invoice'] && itemsDashboard['invoice'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liFactura"
                                                onClick={this.openBilling}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/invoices.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Factura</span>
                                                </span>
                                            </li>}
                                        {/* FACTURA DE ANTICIPO*/}
                                        {itemsDashboard['invoiceAdvance'] && itemsDashboard['invoiceAdvance'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liFacturaAdvance"
                                                onClick={this.opeinvoiceAdvancePayment}>
                                                <span className="nav-link" routerlink="/invoiceAdvance" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/invoices.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Factura de anticipo</span>
                                                </span>
                                            </li>}
                                        {/* DEVOLUCION */}
                                        {itemsDashboard['return'] && itemsDashboard['return'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liDevolucion" onClick={this.openReturn}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/devolucion.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Devolución</span>
                                                </span>
                                            </li>}
                                        {/* NOTA DE DEBITO */}
                                        {itemsDashboard['debitNote'] && itemsDashboard['debitNote'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liDebito" onClick={this.openDebitNote}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/notaDebito.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Nota de Débito</span>
                                                </span>
                                            </li>}
                                        {/* NOTA DE CREDITO */}
                                        {itemsDashboard['creditNote'] && itemsDashboard['creditNote'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liCredito" onClick={this.openCreditNote}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/notaCredito.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Nota de Crédito</span>
                                                </span>
                                            </li>}
                                        {/* FACTURA DE RESERVA DE CLIENTES*/}
                                        {itemsDashboard['invoiceReserve'] && itemsDashboard['invoiceReserve'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liFactura"
                                                onClick={this.opeinvoiceReserve}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/invoices.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Factura de reserva de clientes</span>
                                                </span>
                                            </li>}

                                        {itemsDashboard['pendingTimbraDocs'] && itemsDashboard['pendingTimbraDocs'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liGlobalConfig" onClick={this.OpenPendingTimbraDocs}>
                                                <span className="nav-link" routerlink="/globalConfig" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/globalServices.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Documentos pendientes por timbrar</span>
                                                </span>
                                            </li>
                                        }
                                        {/* DEVOLUCION */}
                                    </ul>
                                </li>
                            }

                            {/* COMPRAS */}
                            {itemsDashboard['mktPurchase'] && itemsDashboard['mktPurchase'].active &&
                                <li className="nav-item cursor-pointer" title="Documentos de Compras" data-toggle="tooltip"
                                    data-placement="right" id="liDocumentosCompras" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-2" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/transfersEntry.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Documentos de Compras</span>
                                    </span>
                                    <ul id="submenu-2" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        {/* SOLICITUD*/}
                                        {itemsDashboard['PurchaseRequest'] && itemsDashboard['PurchaseRequest'].active &&
                                            <li className="nav-item cursor-pointer" title="Solicitud de Compra"

                                                data-toggle="tooltip" data-placement="right" id="liPurchaseRequest" onClick={this.openPurchaseRequest}>
                                                <span className="nav-link" routerlink="/purchaseRequest" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/purchaseRequest.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Solicitud de Compra</span>
                                                </span>
                                            </li>}
                                        {/* OFERTA DE COMPRA*/}
                                        {itemsDashboard['PurchaseQuotation'] && itemsDashboard['PurchaseQuotation'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liPurchaseOrder" onClick={this.openPurchaseQuotation}>
                                                <span className="nav-link" routerlink="/purchaseQuotation" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/purchaseQuotation.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Oferta de Compra</span>
                                                </span>
                                            </li>}
                                        {/* ORDEN DE COMPRA*/}
                                        {itemsDashboard['PurchaseOrder'] && itemsDashboard['PurchaseOrder'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liPurchaseOrder" onClick={this.openPurchaseOrder}>
                                                <span className="nav-link" routerlink="/purchaseOrder" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/purchaseOrder.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Orden de Compra</span>
                                                </span>
                                            </li>}
                                        {/* ENTRADA DE MERCANCIA*/}
                                        {itemsDashboard['GoodsReceipt'] && itemsDashboard['GoodsReceipt'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liGoodsReceipt" onClick={this.openGoodsReceipt}>
                                                <span className="nav-link" routerlink="/goodsReceipt" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/transfersEntry.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Entrada de Mercancía</span>
                                                </span>
                                            </li>}
                                        {/* DEVOLUCION COMPRAS*/}
                                        {itemsDashboard['purchaseReturn'] && itemsDashboard['purchaseReturn'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liPurchaseReturn" onClick={this.openPurchaseReturn}>
                                                <span className="nav-link" routerlink="/purchaseReturns" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/transfersOutput.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Devolución de Mercancía</span>
                                                </span>
                                            </li>}
                                        {/* FACTURA PROVEEDORES*/}
                                        {itemsDashboard['purchaseInvoice'] && itemsDashboard['purchaseInvoice'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liFacturaProveedores" onClick={this.openPurchaseInvoice}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/invoices.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Factura de Proveedores</span>
                                                </span>
                                            </li>}
                                        {/* NOTA DE CRÉDITO PROVEEDORES */}
                                        {itemsDashboard['purchaseCreditNotes'] && itemsDashboard['purchaseCreditNotes'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="lipurchaseCreditNotes" onClick={this.openPurchaseCreditNotes}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/purchaseCreditNotes.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Nota de crédito proveedores</span>
                                                </span>
                                            </li>}
                                        {/* PRECIOS DE ENTREGA */}
                                        {itemsDashboard['landedCosts'] && itemsDashboard['landedCosts'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="landedCosts" onClick={this.openLandedCosts}>
                                                <span className="nav-link" routerlink="/landedCosts" style={{ padding: 5, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/landedCosts.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Precios de Entrega</span>
                                                </span>
                                            </li>}
                                    </ul>
                                </li>
                            }

                            {/* PRELIMINARES */}
                            {itemsDashboard['draftsHead'] && itemsDashboard['draftsHead'].active &&
                                <li className="nav-item cursor-pointer" title="Preliminares" data-toggle="tooltip"
                                    data-placement="right" id="liDocumentosPreliminares" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-10" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/draft.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Preliminares</span>
                                    </span>
                                    <ul id="submenu-10" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        {/* PRELIMINAR*/}
                                        {itemsDashboard['drafts'] && itemsDashboard['drafts'].active &&
                                            <li className="nav-item cursor-pointer" title="Documento Preliminar"

                                                data-toggle="tooltip" data-placement="right" id="liDraftDocument" onClick={this.openDraft}>
                                                <span className="nav-link" routerlink="/draft" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/draft.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Documento Preliminar</span>
                                                </span>
                                            </li>}
                                    </ul>
                                </li>
                            }

                            {/* SOCIOS DE NEGOCIOS */}
                            {itemsDashboard['bussinesPartner'] && itemsDashboard['bussinesPartner'].active &&
                                <li className="nav-item cursor-pointer" title="Socio de Negocios"
                                    data-toggle="tooltip" data-placement="right" id="lisocios">
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-bp" style={{ margin: 0 }}>
                                        <span className="sidebar-icon">
                                            <img src={require('../images/ico/socionegocios.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide " data-toggle="collapse">Socio de Negocios</span>
                                    </span>
                                    <ul id="submenu-bp" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        <li className="nav-item cursor-pointer"
                                            data-toggle="tooltip" data-placement="right" id="liSociosNeg" onClick={this.openBussinesPartner}>
                                            <span className="nav-link" style={{ padding: 4, margin: 0 }}>
                                                <span className="sidebar-icon">
                                                    <img src={require('../images/ico/socionegocios.png')} alt="" className="ico-sidebar" />
                                                </span>
                                                <span className="fadeInRight animated nav-link-name name-hide">Socio de Negocios</span>
                                    </span>
                                        </li>
                                    </ul>
                                </li>
                            }

                            {/* ARTICULOS */}
                            {itemsDashboard['inventoryData'] && itemsDashboard['inventoryData'].active &&
                                <li className="nav-item cursor-pointer" title="Datos de Artículo" data-toggle="tooltip"
                                    data-placement="right" id="liInvetario">
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-inv" style={{ margin: 0 }}>
                                        <span className="sidebar-icon">
                                            <img src={require('../images/ico/MaestroArticulo.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Datos de Artículo</span>
                                    </span>
                                    <ul id="submenu-inv" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        <li className="nav-item cursor-pointer"
                                            data-toggle="tooltip" data-placement="right" id="liDatosArticulo" onClick={this.openInventoryData}>
                                            <span className="nav-link" style={{ padding: 4, margin: 0 }}>
                                                <span className="sidebar-icon">
                                                    <img src={require('../images/ico/MaestroArticulo.png')} alt="" className="ico-sidebar" />
                                                </span>
                                                <span className="fadeInRight animated nav-link-name name-hide">Datos de Artículo</span>
                                    </span>
                                        </li>
                                    </ul>
                                </li>
                            }

                            {/* GESTION DE BANCOS */}
                            {itemsDashboard['banking'] && itemsDashboard['banking'].active &&
                                <li className="nav-item cursor-pointer" title="Gestión de Bancos" data-toggle="tooltip" data-placement="right" id="liGestionBancos" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-3" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/banco.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Gestión de Bancos</span>
                                    </span>
                                    <ul id="submenu-3" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        {/* PAGOS RECIBIDOS */}
                                        {itemsDashboard['payment'] && itemsDashboard['payment'].active &&
                                            <li className="nav-item cursor-pointer" title="Pago" data-toggle="tooltip"
                                                data-placement="right" id="liPago" onClick={this.openPayment}>
                                                <span className="nav-link" routerlink="/billing" >
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/pagos.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Pagos Recibidos</span>
                                                </span>
                                            </li>
                                        }
                                        {/* PAGOS EFECTUADOS */}
                                        {itemsDashboard['outgoingPayment'] && itemsDashboard['outgoingPayment'].active &&
                                            <li className="nav-item cursor-pointer" title="Pagos Efectuados" data-toggle="tooltip"
                                                data-placement="right" id="liPagosEfectuados" onClick={this.openOutgoingPayments}>
                                                <span className="nav-link" routerlink="/Payments" >
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/pago.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Pagos Efectuados</span>
                                                </span>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }

                            {/* OPERACIONES DE STOCK */}
                            {itemsDashboard['inventoryData'] && itemsDashboard['inventoryData'].active &&
                                <li className="nav-item cursor-pointer" title="Datos de Inventario" data-toggle="tooltip" data-placement="right" id="liDatosdeinventario" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-4" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/traslados.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Operaciones de Inventario</span>
                                    </span>
                                    <ul id="submenu-4" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        {/* SOLICITUD DE TRASLADO */}
                                        {itemsDashboard['transfers'] && itemsDashboard['transfers'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liTrasladoRequest" onClick={this.openTransfersRequest}>
                                                <span className="nav-link" routerlink="/transfersRequest" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/transfersRequest.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Solicitud de traslado</span>
                                                </span>
                                            </li>
                                        }
                                        {/* TRASLADO DE STOCK */}
                                        {itemsDashboard['transfersRequest'] && itemsDashboard['transfersRequest'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liTraslado" onClick={this.openTransfers}>
                                                <span className="nav-link" routerlink="/Transfers" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/traslados.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Traslado de Mercancía</span>
                                                </span>
                                            </li>
                                        }
                                        {/* ENTRADA DE MERCANCIA INV */}
                                        {itemsDashboard['transfersEntry'] && itemsDashboard['transfersEntry'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liTrasladoEntry" onClick={this.openTransfersEntry}>
                                                <span className="nav-link" routerlink="/transfersEntry" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/transfersEntry.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Entrada de Mercancía</span>
                                                </span>
                                            </li>
                                        }
                                        {/* SALIDA DE MERCANCIA INV*/}
                                        {itemsDashboard['transfersOutput'] && itemsDashboard['transfersOutput'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liTrasladoOutput" onClick={this.openTransfersOutput}>
                                                <span className="nav-link" routerlink="/transfersOutput" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/transfersOutput.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Salida de Mercancía</span>
                                                </span>
                                            </li>
                                        }

                                        {/* LISTA DE PRECIOSA */}
                                        {itemsDashboard['priceList'] && itemsDashboard['priceList'].active &&
                                            <li className="nav-item cursor-pointer" title="Lista de Precios" data-toggle="tooltip"
                                                data-placement="right" id="liPriceList" onClick={this.openPriceList}>
                                                <span className="nav-link" routerlink="/priceLists" >
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/PriceLists.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Lista de Precios</span>
                                                </span>
                                            </li>
                                        }

                                        {/* REVALORIZACION */}
                                        {itemsDashboard['inventoryRevaluation'] && itemsDashboard['inventoryRevaluation'].active && false &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liInventoryRevaluation" onClick={this.openInventoryRevaluation}>
                                                <span className="nav-link" routerlink="/inventoryRevaluation" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/trasladosEntry.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Revalorización de Inventario</span>
                                                </span>
                                            </li>
                                        }
                                        {/* AUDITORIA DE STOCK */}
                                        {false && itemsDashboard['stockAudit'] && itemsDashboard['stockAudit'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liInventoryReports" onClick={this.openinventoryReports}>
                                                <span className="nav-link" routerlink="/inventoryReports" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/trasladosEntry.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Informe de Auditoría de Stocks</span>
                                                </span>
                                            </li>
                                        }
                                        {/* REABASTECIMIENTO ADMIN */}
                                        {itemsDashboard['reabsResume'] && itemsDashboard['reabsResume'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liReabsResume" onClick={this.openReabsResume}>
                                                <span className="nav-link" routerlink="/ReabsResume" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/traslados.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Reabastecimiento</span>
                                                </span>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }

                            {/* PRODUCCIÓN */}
                            {['productTree', 'productionOrder', 'goodsReceiptProd', 'goodsIssue'
                                // , 'provConfAssistant'
                            ].some(item => itemsDashboard[item]?.active) &&
                                <li className="nav-item cursor-pointer" title="Producción" data-toggle="tooltip" data-placement="right" id="liProduccion" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-11" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/goodsIssue.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Producción</span>
                                    </span>
                                    <ul id="submenu-11" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        {/* LISTA DE MATERIALES */}
                                        {itemsDashboard['productTree'] && itemsDashboard['productTree'].active &&
                                            <li className="nav-item cursor-pointer" title="Lista de Materiales" data-toggle="tooltip"
                                                data-placement="right" id="liListaDeMateriales" onClick={this.openProductTree}>
                                                <span className="nav-link" routerlink="/productTree" >
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/productTree.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Lista de Materiales</span>
                                                </span>
                                            </li>
                                        }
                                        {/* ORDEN DE FABRICACIÓN */}
                                        {itemsDashboard['productionOrder'] && itemsDashboard['productionOrder'].active &&
                                            <li className="nav-item cursor-pointer" title="Orden de Fabricación" data-toggle="tooltip"
                                                data-placement="right" id="liOrdenDeFabricacion" onClick={this.openProductionOrder}>
                                                <span className="nav-link" routerlink="/productionOrder" >
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/productionOrder.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Orden de Fabricación</span>
                                                </span>
                                            </li>
                                        }
                                        {/* EMISIÓN PARA PRODUCCIÓN */}
                                        {itemsDashboard['goodsIssue'] && itemsDashboard['goodsIssue'].active &&
                                            <li className="nav-item cursor-pointer" title="Emisión para producción" data-toggle="tooltip"
                                                data-placement="right" id="liEmisionParaProduccion" onClick={this.openGoodsIssue}>
                                                <span className="nav-link" routerlink="/goodsIssue" >
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/goodsIssue.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Emisión para producción</span>
                                                </span>
                                            </li>
                                        }
                                        {/* RECIBO DE PRODUCCIÓN */}
                                        {itemsDashboard['goodsReceiptProd'] && itemsDashboard['goodsReceiptProd'].active &&
                                            <li className="nav-item cursor-pointer" title="Recibo de producción" data-toggle="tooltip"
                                                data-placement="right" id="liReciboDeProduccion" onClick={this.openGoodsReceiptProd}>
                                                <span className="nav-link" routerlink="/goodsReceiptProd" >
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/goodsReceiptProd.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Recibo de producción</span>
                                                </span>
                                            </li>
                                        }
                                        {/* ASISTENTE DE CONFIRMACIÓN DE APROVISIONAMIENTO */}
                                        {false && itemsDashboard['provConfAssistant'] && itemsDashboard['provConfAssistant'].active &&
                                            <li className="nav-item cursor-pointer" title="Asistente de confirmación de aprovisionamiento" data-toggle="tooltip"
                                                data-placement="right" id="liAsistenteDeConfirmacionDeAprovisionamiento" onClick={this.openProvConfAssistant}>
                                                <span className="nav-link" routerlink="/provConfAssistant" >
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/provConfAssistant.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Asistente de confirmación<br></br>de aprovisionamiento</span>
                                                </span>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }

                            {/* AUTORIZACIONES*/}
                            {itemsDashboard['inzi'] && itemsDashboard['inzi'].active &&
                                <li className="nav-item cursor-pointer" title="Autorizaciones" data-toggle="tooltip" data-placement="right" id="liAuthotizations" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-5" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/authorizations.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Autorizaciones</span>
                                    </span>
                                    <ul id="submenu-5" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>

                                        {itemsDashboard['invoiceAuthorization'] && itemsDashboard['invoiceAuthorization'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liFacturaAuth" onClick={this.openBillingAuthorization}>
                                                <span className="nav-link" routerlink="/billingAuthorization" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/invoicesAuthorization.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Documentos por Autorizar</span>
                                                </span>
                                            </li>
                                        }
                                        {itemsDashboard['invoiceBorrador'] && itemsDashboard['invoiceBorrador'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liFacturaBorrador" onClick={this.openBillingBorrador}>
                                                <span className="nav-link" routerlink="/billingBorrador" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/invoicesBorrador.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Documentos Autorizados</span>
                                                </span>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }

                            {/* ACCIONES INTERNAS */}
                            {itemsDashboard['actions'] && itemsDashboard['actions'].active &&
                                <li className="nav-item cursor-pointer" title="Acctiones Internas" data-toggle="tooltip" data-placement="right" id="liActions" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-6" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/reset.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Acciones Internas</span>
                                    </span>
                                    <ul id="submenu-6" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>

                                        {itemsDashboard['administratorUsers'] && itemsDashboard['administratorUsers'].active && (superUser || (_user && _user?.E_Mail && (_user.E_Mail === Datos_Empresa.CorreoAdminUser || _user.E_Mail === 'desarrollo2@fmbsolutions.mx'))) &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liAdminUsers" onClick={this.openAdminUsers}>
                                                <span className="nav-link" routerlink="/AdminUsers" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/adminUsers.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Administración de Usuarios</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['queryManager'] && itemsDashboard['queryManager'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liConsultas" onClick={this.openQuery}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/query.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Consultas</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['sucursales'] && itemsDashboard['sucursales'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liSucursales" onClick={this.openSucursales}>
                                                <span className="nav-link" routerlink="/sucursales" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/sucursal.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Sucursales</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['globalConfig'] && itemsDashboard['globalConfig'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liGlobalConfig" onClick={this.openGlobalConfig}>
                                                <span className="nav-link" routerlink="/globalConfig" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/globalServices.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Config. Global</span>
                                                </span>
                                            </li>
                                        }

                                        {false && itemsDashboard['invoiceBorrador'] && itemsDashboard['invoiceBorrador'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liMiddleware" onClick={this.openMiddleware}>
                                                <span className="nav-link" routerlink="/billing" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/auto.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Middleware</span>
                                                </span>
                                            </li>
                                        }

                                    </ul>
                                </li>
                            }

                            {/* CARTA PORTE */}
                            {itemsDashboard['consignmentNoteManagement'] && itemsDashboard['consignmentNoteManagement'].active &&
                                <li className="nav-item cursor-pointer" title="Gestion de Cartas Porte" data-toggle="tooltip" data-placement="right" id="liConsignmentNoteManagement" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-8" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/NUEVOS_CARTA_PORTE.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Gestión de Cartas Porte</span>
                                    </span>
                                    <ul id="submenu-8" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>

                                        {itemsDashboard['figuresTransport'] && itemsDashboard['figuresTransport'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liFiguraTransporte" onClick={this.openFiguraTransporte}>
                                                <span className="nav-link" routerlink="/figuraTransporte" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/NUEVOS_CHOFERES.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Figuras Transporte</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['transports'] && itemsDashboard['transports'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liTransporte" onClick={this.openTransporte}>
                                                <span className="nav-link" routerlink="/transporte" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/NUEVOS_CAMIONES.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Transportes</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['consignmentNote'] && itemsDashboard['consignmentNote'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liCartaPorte" onClick={this.openCartaPorte}>
                                                <span className="nav-link" routerlink="/cartaPorte" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/NUEVOS_CARTA_PORTE.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Carta Porte</span>
                                                </span>
                                            </li>
                                        }

                                    </ul>
                                </li>
                            }

                            {/* COUNTER ONE */}
                            {itemsDashboard['counter'] && itemsDashboard['counter'].active &&
                                <li className="nav-item cursor-pointer" title="Punto de venta" data-toggle="tooltip"
                                    data-placement="right" id="liAdminPuntoVenta" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-7" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/puntoVenta.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Punto de venta</span>
                                    </span>
                                    <ul id="submenu-7" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>
                                        {itemsDashboard['pointSales'] && itemsDashboard['pointSales'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liPointOfSale" onClick={this.openPointOfSale}>
                                                <span className="nav-link" routerlink="/POS" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/pos.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Venta de Mostrador</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['counterReturns'] && itemsDashboard['counterReturns'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liPointOfSale" onClick={() => this.openLink("/counterReturns")}>
                                                <span className="nav-link" routerlink="/POS" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/devolu.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Devolución y/o Cancelaciones</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['inventoryPS'] && itemsDashboard['inventoryPS'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liInventory" onClick={this.openInventory}>
                                                <span className="nav-link" routerlink="/inventory" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/inventario.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Inventario</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['reportsPS'] && itemsDashboard['reportsPS'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liInventory" onClick={this.openReportSales}>
                                                <span className="nav-link" routerlink="/reportSales" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/reportes.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Reportes</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['partnerDocuments'] && itemsDashboard['partnerDocuments'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liInventory" onClick={this.partnerDocuments}>
                                                <span className="nav-link" routerlink="/partnerDocuments" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/quotations.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide "> Documentos por Cliente</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['payments'] && itemsDashboard['payments'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liCollect" onClick={this.openCollect}>
                                                <span className="nav-link" routerlink="/reportSales" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/cobranza.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Cobranza</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['incomingPaymentsPS'] && itemsDashboard['incomingPaymentsPS'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liBankDeposits" onClick={this.openBankDeposits}>
                                                <span className="nav-link" routerlink="/bankDeposits" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/depositos.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Depósitos bancarios</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['prints'] && itemsDashboard['prints'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liRePrint" onClick={this.openRePrint}>
                                                <span className="nav-link" routerlink="/rePrint" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/impresion.png')} alt="" className="ico-sidebar" style={{ maxWidth: "22px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Re-impresión</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['closuresPS'] && itemsDashboard['closuresPS'].active &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liClosures" onClick={this.openClosures}>
                                                <span className="nav-link" routerlink="/closures" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/close.png')} alt="" className="ico-sidebar" style={{ maxWidth: "19px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Cierres y cortes</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['branchClosuresPS'] && itemsDashboard['branchClosuresPS'].active && _user && _user?.USER_CODE === "manager" &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liBranchClosures" onClick={this.openBranchClosures}>
                                                <span className="nav-link" routerlink="/branchClosures" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/close.png')} alt="" className="ico-sidebar" style={{ maxWidth: "19px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Cierres de sucursales</span>
                                                </span>
                                            </li>
                                        }

                                        {itemsDashboard['pointsCard'] && itemsDashboard['pointsCard'].active && points_Card &&
                                            <li className="nav-item cursor-pointer" data-toggle="tooltip"
                                                data-placement="right" id="liClosures" onClick={this.openPointsCard}>
                                                <span className="nav-link" routerlink="/closures" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/pointsCard.png')} alt="" className="ico-sidebar" style={{ maxWidth: "19px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Monedero Electrónico</span>
                                                </span>
                                            </li>
                                        }
                                        {/* TRASPADO DE CORTES ADMIN */}
                                        {itemsDashboard['cutTransfers'] && itemsDashboard['cutTransfers'].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liCutTransfers" onClick={this.openCutTransfers}>
                                                <span className="nav-link" routerlink="/CutTransfers" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/invoicesBorrador.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Traspaso de Cortes</span>
                                                </span>
                                            </li>
                                        }

                                    </ul>
                                </li>
                            }


                            {false && itemsDashboard[0] && itemsDashboard[0].active &&
                                <li className="nav-item cursor-pointer" title="Cascos" data-toggle="tooltip" data-placement="right" id="liCascos" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-4" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/bateria.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Cascos</span>
                                    </span>
                                    <ul id="submenu-4" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>

                                        {false && itemsDashboard[0] && itemsDashboard[0].active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liSalesHelmets" onClick={this.openSalesHelmets}>
                                                <span className="nav-link" routerlink="/salesHelmets" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/transfersEntry.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span
                                                        className="fadeInRight animated nav-link-name name-hide ">Entrada de Mercancía Cascos</span>
                                                </span>
                                            </li>
                                        }

                                        {false && itemsDashboard[0] && itemsDashboard[0].active && false &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="liExitHelmets" onClick={this.openExitHelmets}>
                                                <span className="nav-link" routerlink="/exitHelmets" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/transfersOutput.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span
                                                        className="fadeInRight animated nav-link-name name-hide ">Salida de Mercancía Cascos</span>
                                                </span>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }
                            {/* M-VENTAS */}
                            {itemsDashboard['mVentas'] && itemsDashboard['mVentas'].active &&
                                <li className="nav-item cursor-pointer" title="Gestión M-Ventas" data-toggle="tooltip" data-placement="right" id="liMVentas" >
                                    <span className="subMenu nav-link" data-toggle="collapse" data-target="#submenu-9" style={{ margin: 0 }} >
                                        <span className="sidebar-icon text-center">
                                            <img src={require('../images/ico/mobileConfigIcon.png')} alt="" className="ico-sidebar" />
                                        </span>
                                        <span className="fadeInRight animated nav-link-name name-hide" data-toggle="collapse">Gestión M-Ventas</span>
                                    </span>
                                    <ul id="submenu-9" className="collapse" style={{ listStyle: 'none', paddingLeft: '15px' }}>

                                        {((itemsDashboard['mAdminUser'] && itemsDashboard['mAdminUser'].active) || superUser) &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="limVAdminUser" onClick={this.openmVAdminUsers}>
                                                <span className="nav-link" routerlink="/mVAdminUser" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/adminUsers.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Admin. de Usuarios</span>
                                                </span>
                                            </li>
                                        }

                                        {((itemsDashboard['canalizadoAdmin'] && itemsDashboard['canalizadoAdmin'].active) || superUser) &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                id="limVAdminUser" onClick={this.openCanalizados}>
                                                <span className="nav-link" routerlink="/mVAdminUser" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon text-center">
                                                        <img src={require('../images/ico/gas.png')} alt="" className="ico-sidebar" style={{ height: "auto", width: "21px" }} />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Canalizados</span>
                                                </span>
                                            </li>
                                        }
                                        {/* Muestra el reporte de Soporte junto a los demás módulos habilitados para el usuario. */}
                                        {itemsDashboard['pendingCuts']?.active &&
                                            <li className="nav-item cursor-pointer"
                                                data-toggle="tooltip" data-placement="right" id="liPendingCuts" onClick={this.openPendingCuts}>
                                                <span className="nav-link" routerlink="/PendingCuts" style={{ padding: 4, margin: 0 }}>
                                                    <span className="sidebar-icon">
                                                        <img src={require('../images/ico/corteC.png')} alt="" className="ico-sidebar" />
                                                    </span>
                                                    <span className="fadeInRight animated nav-link-name name-hide ">Cortes Pendientes</span>
                                                </span>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }

                        </ul>
                    </nav>
                </div>

                <div className="background-opacity small-side-bar" style={{ position: 'fixed' }}>
                    <div className="Footer-FMB">
                        {/* FOOTER */}
                        <div className="text-footer text-muted">
                            <div className='row mr-0 ml-0'>
                                <div className='col-4' style={{ fontSize: 10, paddingLeft: '5px', paddingRight: '5px' }}>
                                    <label>{`SUC.:${_user && _user.Sucursal && _user.Sucursal !== '' ? _user.Sucursal : 'Sin nombre'} ALM:${_user && _user.Branch && _user.Branch.AccountDefault.length > 0 ? decodeText(_user.Branch.AccountDefault[0].WhsName) : 'Sin almacén'}`}</label>
                                </div>
                                <div className='col-4' style={{ fontSize: 10, paddingLeft: '5px', paddingRight: '5px' }}>
                                    <a href="https://fmbsolutions.mx/" className="text-muted" target="_blank" rel="noopener noreferrer">®FMB-Solutions  </a>- Todos los Derechos Reservados V{currentVersion}
                                </div>
                                <div className='col-4' style={{ fontSize: 10, paddingLeft: '5px', paddingRight: '5px' }}>
                                    <label className=''>{`${moment().format('MMMM Do YYYY, h:mm:ss a')}`}</label>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default NavBar;
